export default __webpack_public_path__ + "static/media/organized.7d1e6d12.svg";